// src/pages/Creators.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../utils/auth";
import "../styles/styles.css";

const Creators = () => {
  const navigate = useNavigate();
  const user = getCurrentUser();

  const [title, setTitle] = useState("");
  const [synopsis, setSynopsis] = useState("");
  const [genres, setGenres] = useState([]);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const allGenres = [
    "Acción",
    "Drama",
    "Comedia",
    "Ciencia Ficción",
    "Romance",
    "Suspense",
    "Terror",
  ];

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  const handleGenreChange = (e) => {
    const { value, checked } = e.target;
    setGenres(checked ? [...genres, value] : genres.filter((g) => g !== value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");

    if (!title.trim() || !synopsis.trim() || genres.length === 0) {
      setError("Por favor, completa todos los campos obligatorios.");
      return;
    }

    try {
      const res = await fetch("http://localhost:8080/api/submissions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title,
          synopsis,
          genres,
          submittedBy: user.email,
        }),
      });

      if (!res.ok) {
        const errText = await res.text();
        throw new Error(errText || "Error al enviar el pitch.");
      }

      setSuccessMsg("Tu propuesta ha sido enviada. Revisa tu correo.");
      setTitle("");
      setSynopsis("");
      setGenres([]);
    } catch (err) {
      console.error("Error enviando pitch:", err);
      setError("Hubo un problema al enviar el pitch.");
    }
  };

  return (
    <div className="upload-container">
      <h2>Presenta tu proyecto a “IA Creators”</h2>
      <p style={{ color: "var(--color-text-secondary)", marginBottom: "1rem" }}>
        Rellena este formulario para enviar un pitch de tu serie/película generada con IA. Nuestro equipo revisará y, si lo aprueba, te invitaremos a subir el contenido completo.
      </p>
      {error && <p className="error-message">{error}</p>}
      {successMsg && <p className="success-message">{successMsg}</p>}
      <form onSubmit={handleSubmit} className="upload-form">
        <label htmlFor="title">Título del proyecto*:</label>
        <input
          type="text"
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <label htmlFor="synopsis">Sinopsis breve* (2–3 párrafos):</label>
        <textarea
          id="synopsis"
          value={synopsis}
          onChange={(e) => setSynopsis(e.target.value)}
          rows="4"
          required
        />

        <fieldset className="genre-fieldset">
          <legend>Géneros*:</legend>
          <div className="genre-options">
            {allGenres.map((g) => (
              <label key={g} className="genre-label">
                <input
                  type="checkbox"
                  value={g}
                  checked={genres.includes(g)}
                  onChange={handleGenreChange}
                />
                {g}
              </label>
            ))}
          </div>
        </fieldset>

        <button type="submit" className="btn-submit">
          Enviar Pitch
        </button>
      </form>
    </div>
  );
};

export default Creators;
